import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarChartAnsweredComponent } from './bar-chart-answered.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';


@NgModule({
  imports: [
    CommonModule,
    NgxChartsModule,
  ],
  declarations: [BarChartAnsweredComponent],
  exports:[BarChartAnsweredComponent],
})
export class BarChartAnsweredModule { }
